module.exports = __webpack_public_path__ + "img/bolzoni-logo.10f2b79c.jpg";